import { lazy } from 'react'
import {
  DashboardOutlined,
  ShopOutlined,
  TagsOutlined,
  PercentageOutlined,
  GiftOutlined,
  LineChartOutlined,
  CustomerServiceOutlined,
  QrcodeOutlined,
} from '@ant-design/icons'

import lazyComponent from './lazy'
import { DASHBOARD_ALLOWED_ROLES, DASHBOARD_REPORTS_ALLOWED_ROLES } from '../util/stateAccess'

const MiNegocio = lazy(() => import('../containers/Dashboard/MiNegocio'))
const DiscountsAdmin = lazy(() => import('../containers/Dashboard/Discounts'))
const PromotionsAdmin = lazy(() => import('../containers/Dashboard/Promotions'))
const DailyDiscount = lazy(() => import('../containers/Dashboard/DailyDiscount'))
const GiftCertificates = lazy(() => import('../containers/Dashboard/GiftCertificates'))
const Support = lazy(() => import('../containers/Dashboard/Support'))
const Redeem = lazy(() => import('../containers/Dashboard/Redeem'))
const ReportsModule = lazy(() => import('../containers/Dashboard/Reports'))

const states = [
  {
    key: 'view_dashboard',
    url: 'dashboard',
    name: 'App.Dashboard',
    title: 'Dashboard',
    redirectTo: 'App.Dashboard.MiNegocio',
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <DashboardOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_minegocio',
    url: '/mi-negocio',
    name: 'App.Dashboard.MiNegocio',
    title: 'Mi Negocio',
    views: {
      'main@App': lazyComponent(MiNegocio),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <ShopOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_descuentos',
    url: '/descuentos',
    name: 'App.Dashboard.Descuentos',
    title: 'Descuentos',
    views: {
      'main@App': lazyComponent(DiscountsAdmin),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
        icon: <TagsOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_descuentos_dia',
    url: '/descuentos-del-dia',
    name: 'App.Dashboard.DescuentosDelDia',
    title: 'Descuentos del Día',
    views: {
      'main@App': lazyComponent(DailyDiscount),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
        icon: <PercentageOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_promociones',
    url: '/promociones',
    name: 'App.Dashboard.Promociones',
    title: 'Promociones',
    views: {
      'main@App': lazyComponent(PromotionsAdmin),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 3,
        icon: <TagsOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_certificados',
    url: '/certificados',
    name: 'App.Dashboard.Certificados',
    title: 'Certificados',
    views: {
      'main@App': lazyComponent(GiftCertificates),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 4,
        icon: <GiftOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_reportes',
    url: '/reportes',
    name: 'App.Dashboard.Reportes',
    title: 'Reportes',
    views: {
      'main@App': lazyComponent(ReportsModule),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 5,
        icon: <LineChartOutlined />,
      },
      roles: DASHBOARD_REPORTS_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_soporte',
    url: '/soporte',
    name: 'App.Dashboard.Soporte',
    title: 'Soporte',
    views: {
      'main@App': lazyComponent(Support),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 6,
        icon: <CustomerServiceOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_dashboard_canjes',
    url: '/canjes',
    name: 'App.Dashboard.Canjes',
    title: 'Canjes',
    views: {
      'main@App': lazyComponent(Redeem),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 7,
        icon: <QrcodeOutlined />,
      },
      roles: DASHBOARD_ALLOWED_ROLES,
    },
  },
]

export default states
